import { useEffect, useRef } from "react";

function StreamingServerVideo({ show }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const modal = document.getElementById("streamingServerVideoModal");

    const handleModalHidden = () => {
      if (videoRef.current) {
        videoRef.current.pause();          // Stop the video
        videoRef.current.currentTime = 0;  // Rewind to start
      }
    };

    modal.addEventListener("hidden.bs.modal", handleModalHidden);

    return () => {
      modal.removeEventListener("hidden.bs.modal", handleModalHidden);
    };
  }, []);

  return (
    <div
      className={`modal fade home-video-modal ${show ? "show d-block" : ""}`}
      id="streamingServerVideoModal"
      tabIndex="-1"
      aria-hidden={!show}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content animate-modal bg-dark">
          <div className="modal-body p-0">
            <video
              ref={videoRef}
              id="modalVideo"
              controls
              autoPlay
              muted
              width="100%"
            >
              <source
                src={`${import.meta.env.VITE_FRONTEND_URL}/images/streaming-server-video-yt.mp4`}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StreamingServerVideo;
